import React, { Component } from 'react';
import { connect } from 'react-redux';
import DownloadPdf from 'wt-react/dist/components/DownloadPdf/DownloadPdf';
import i18n from './../../../i18n';
import ReactTooltip from 'react-tooltip';
import './FactSheetDownload.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFilePdf as faFilePdfRegular,
  faFileLines as faFileLinesRegular,
} from '@fortawesome/free-regular-svg-icons';

class FactSheetDownload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPdfModal: false,
    };
  }

  toggleShowPdfModal = () => {
    this.setState({ showPdfModal: !this.state.showPdfModal });
  };

  renderPdf = () => {
    const {
      token,
      clientEmail,
      pdfReportConfigId,
      personalStrategiesIncomePdfId,
      personalStrategiesGrowthPdfId,
      personalStrategyID,
      type,
      personalStrategyModelType,
      tooltip,
      iconOnly = false,
    } = this.props;
    const { showPdfModal } = this.state;
    const tooltipId = `hover-tip-pdf-${type || 'pdf'}-${
      personalStrategyID || 'default'
    }`;

    let configID;

    if (type === 'commentary') {
      const normalizedModelType = (
        personalStrategyModelType || ''
      ).toLowerCase();
      if (normalizedModelType.includes('strategic')) {
        configID = personalStrategiesGrowthPdfId || pdfReportConfigId;
      } else if (normalizedModelType.includes('dividend')) {
        configID = personalStrategiesIncomePdfId || pdfReportConfigId;
      } else {
        // Unknown/other model types: try growth first, then income, then pdf
        configID =
          personalStrategiesGrowthPdfId ||
          personalStrategiesIncomePdfId ||
          pdfReportConfigId;
      }
    } else {
      configID = pdfReportConfigId;
    }

    const initialButtonText =
      type === 'commentary'
        ? i18n.t('commentary-download-text')
        : i18n.t('pdf-download-text');
    const modalTitleText =
      type === 'commentary'
        ? i18n.t('commentary-download-text')
        : i18n.t('pdf-download-text');
    const waitingMessageText = i18n.t('pdf-waiting-message-text');

    const faIcon =
      type === 'commentary' ? faFileLinesRegular : faFilePdfRegular;
    const iconClass =
      'pdf-fa-icon' + (type === 'commentary' ? ' pdf-fa-icon--commentary' : '');

    return (
      <>
        {iconOnly ? (
          <button
            className={`pdf-icon-btn icon-only-btn ${
              type === 'commentary' ? 'pdf-icon-btn--commentary' : ''
            }`}
            onClick={this.toggleShowPdfModal}
            data-tip
            data-for={tooltipId}
            aria-label={initialButtonText}
            title={initialButtonText}
          >
            <FontAwesomeIcon
              icon={faIcon}
              title={initialButtonText}
              className={iconClass}
            />
          </button>
        ) : (
          <button
            className="button"
            onClick={this.toggleShowPdfModal}
            data-tip
            data-for="hover-tip-pdf"
          >
            {initialButtonText}
          </button>
        )}
        <ReactTooltip
          key={tooltipId}
          id={tooltipId}
          type="light"
          className="tooltip"
          effect="float"
          multiline={false}
        >
          {tooltip}
        </ReactTooltip>
        {showPdfModal && (
          <DownloadPdf
            token={token}
            clientEmail={clientEmail}
            configId={configID}
            initialButtonText={initialButtonText}
            modalTitleText={modalTitleText}
            waitingMessageText={waitingMessageText}
            dataspanApiUrl={process.env.REACT_APP_API_URL}
            dpdApiUrl={process.env.REACT_APP_DPD_URL}
            openModalOnLoad={true}
            submitOnLoad={false}
            showCloseText={false}
            callbackOnClose={this.toggleShowPdfModal}
            adhocInputs={[
              { name: 'id', type: 'string', value: personalStrategyID },
              { name: 'token', type: 'string', value: token },
              { name: 'email', type: 'string', value: clientEmail },
            ]}
          />
        )}
      </>
    );
  };

  render() {
    const { openMenu } = this.props;

    if (!openMenu) {
      return null;
    }

    return <>{this.renderPdf()}</>;
  }
}

const mapStateToProps = (state) => ({
  token: state.params.token,
  clientEmail: state.params.clientEmail,
  pdfReportConfigId: state.params.pdfReportConfigId,
  personalStrategiesIncomePdfId: state.params.personalStrategiesIncomePdfId,
  personalStrategiesGrowthPdfId: state.params.personalStrategiesGrowthPdfId,
});

export default connect(mapStateToProps)(FactSheetDownload);
